import { proxy, subscribe, useSnapshot } from "valtio";
import { getMe, MembershipTier, User } from "../api/user";
import { getFromStorage, setStorage } from "@shared/utils";

interface AuthState {
	accessToken?: string;
	user?: User;
	isLoading: boolean;
}

const saved = getFromStorage("auth", { isLoading: false });

export const authState = proxy<AuthState>(saved);

subscribe(authState, () => {
	setStorage("auth", {
		accessToken: authState.accessToken,
		user: authState.user,
	});
});

export const useAuth = () => {
	const authSnap = useSnapshot(authState);

	const isAuthenticated = !!authSnap?.accessToken;

	return { isAuthenticated, user: authSnap.user };
};

export const useHasTier = (tier: MembershipTier) => {
	const { user } = useAuth();
	if (!user?.membershipTier) {
		return false;
	}
	if (user?.membershipTier === "admin") {
		return true;
	}
	if (user?.membershipTier === "Challenger" || user?.membershipTier === "Diamond") {
		return true;
	}

	console.error(`Unknown tier used ${user?.membershipTier}`);

	return false;
};

export const updateAuthUser = async () => {
	if (!authState?.accessToken || authState.isLoading) {
		return;
	}

	try {
		authState.isLoading = true;
		const result = await getMe();

		if (!result.ok) {
			authState.accessToken = undefined;
			authState.user = undefined;
			return;
		}

		authState.user = result.user;
	} finally {
		authState.isLoading = false;
	}
};
